import { handleGetRequest } from './utils';

const getBreaksForPersonnelApiRequest = async personnelId => handleGetRequest(`/business/breaks/${personnelId}`);

export { getBreaksForPersonnelApiRequest };
